import apiClient from './client';
import {ClassContextResponseMessage} from '@/types/ClassContextResponse';

/**
 * Fetches the class context list of video subjects for the given lingo and class.
 * Chooses secure or public endpoint based on authentication state.
 * @param titleLingo Lingo code for content filtering
 * @param titleClass Class code for content filtering
 * @param extraClass Extra code for content filtering
 * @param secure Whether to use secure (/secure) or public (/public) endpoint
 */
export async function fetchClassContext(
    titleLingo: string,
    titleClass: string,
    extraClass: string,
    secure: boolean = true
): Promise<ClassContextResponseMessage> {
  const params: Record<string, string> = {};
  if (extraClass) params.extraClass = extraClass;
  const prefix = secure ? '/secure/class/context' : '/public/class/context';
  const response = await apiClient.get<ClassContextResponseMessage>(
      `${prefix}/${encodeURIComponent(titleClass)}/${encodeURIComponent(titleLingo)}`,
      { params }
  );
  return response.data;
}
